import { useCallback } from "react";
import classNames from "classnames";
import { useFormikContext } from "formik";

import FormikInput from "../FormikInput";
import { noop } from "@helpers/common";
import { moneyPipe } from "@helpers/price";
import {
  MAX_USD_PRICE,
  MIN_USD_PRICE,
  USD_DECIMAL_PART,
} from "@validation/lengthConstants";

import styles from "./index.module.scss";

const PriceInput = ({
  allowEmptyValue,
  placeholder,
  wrapperClassName,
  inputClassName,
  priceName = "price",
  onAfterChange = noop,
  onChange,
  onBlur,
  hideError,
  mask,
  alwaysShowMask,
  disabled,
  label,
  withoutTouch,
}) => {
  const { setFieldValue } = useFormikContext();

  const handleMinMaxPrice = useCallback(
    (value) => {
      if (!value && allowEmptyValue) {
        setFieldValue(priceName, "");
        return;
      }

      const val = Math.max(Math.min(MAX_USD_PRICE, value), MIN_USD_PRICE);

      setFieldValue(priceName, val);
      onAfterChange(val);
    },
    [allowEmptyValue, priceName, onAfterChange, setFieldValue],
  );

  const handleBlur = ({ target }) => handleMinMaxPrice(target.value);

  const formatter = moneyPipe(USD_DECIMAL_PART);

  return (
    <div className={classNames("d-flex", wrapperClassName)}>
      <FormikInput
        prefixClassName={styles.prefix}
        PrefixIcon={() => <span className="text-primary">$</span>}
        alwaysShowMask={alwaysShowMask}
        hideError={hideError}
        formatter={formatter}
        wrapperClassName="w-100 pb-0"
        name={priceName}
        label={label}
        mask={mask}
        className={classNames(inputClassName, styles.input)}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        onBlur={typeof onBlur === "function" ? onBlur : handleBlur}
        type="number"
        withoutTouch={withoutTouch}
      />
    </div>
  );
};

export default PriceInput;
